import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import "./index.css"

export const CommonBreadCrumb = (props) => {

    return (
        <Breadcrumb className="quattrocentosans bold">
            {
                props.data.map((val, index) => {

                    const uniqueKey = `${val.name}-${val.link || index}`;

                    if (val.link !== '') {
                        return (
                            <BreadcrumbItem key={uniqueKey}>
                                <a className="breadcrumb-link font-weight-bold text-dark" href={val.link}>
                                    {val.name}
                                </a>
                            </BreadcrumbItem>
                        );
                    } else {
                        return (
                            <BreadcrumbItem key={uniqueKey} className="breadcrumb-link font-weight-bold text-dark" active>
                                {val.name}
                            </BreadcrumbItem>
                        );
                    }
                })
            }
        </Breadcrumb>
    )
}


// WEBPACK FOOTER //
// ./src/_components/common/CommonBreadCrumb/index.js